import { render, staticRenderFns } from "./VideosYT.vue?vue&type=template&id=10b0d87b&scoped=true&"
import script from "./VideosYT.vue?vue&type=script&lang=js&"
export * from "./VideosYT.vue?vue&type=script&lang=js&"
import style0 from "./VideosYT.vue?vue&type=style&index=0&id=10b0d87b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b0d87b",
  null
  
)

export default component.exports